import React from 'react';
import InteractiveTextViewer from './InteractiveTextViewer';
import TitleInteractiveTextViewer from './TitleInteractiveTextViewer';
import PropTypes from 'prop-types';

const LongPostInteractiveTextViewer = ({ 
    formattedText, 
    textId, 
    style = {},
    onWordDisplayed = null,
    chunkOrder = null
}) => {
    // Function to detect if content is a title based on HTML structure
    const detectTitleLevel = (htmlContent) => {
        // Check for heading tags in order of priority
        const headingMatches = [
            { tag: 'h1', level: 1 },
            { tag: 'h2', level: 2 },
            { tag: 'h3', level: 3 },
            { tag: 'h4', level: 4 },
            { tag: 'h5', level: 5 },
            { tag: 'h6', level: 6 }
        ];
        
        for (const { tag, level } of headingMatches) {
            const regex = new RegExp(`<${tag}[^>]*>`, 'i');
            if (regex.test(htmlContent)) {
                return level;
            }
        }
        
        return null; // Not a title
    };

    const titleLevel = detectTitleLevel(formattedText);
    
    // If it's a title, use TitleInteractiveTextViewer
    if (titleLevel) {
        return (
            <TitleInteractiveTextViewer
                formattedText={formattedText}
                textId={textId}
                level={titleLevel}
                style={style}
                onWordDisplayed={onWordDisplayed}
                chunkOrder={chunkOrder}
                centerAlign={false}
            />
        );
    }

    // Otherwise, use regular InteractiveTextViewer for content
    const longPostStyle = {
        lineHeight: 1.8,
        fontSize: '1.1rem',
        fontFamily: 'Georgia, serif',
        textAlign: 'justify',
        color: '#333',
        ...style
    };

    return (
        <InteractiveTextViewer
            formattedText={formattedText}
            textId={textId}
            baseClassName="long-post-interactive-text"
            style={longPostStyle}
            source={{ 
                type: 'long_post', 
                id: textId, 
                chunkOrder: chunkOrder 
            }}
            onWordDisplayed={onWordDisplayed}
        />
    );
};

LongPostInteractiveTextViewer.propTypes = {
    formattedText: PropTypes.string.isRequired,
    textId: PropTypes.string.isRequired,
    style: PropTypes.object,
    onWordDisplayed: PropTypes.func,
    chunkOrder: PropTypes.number
};

export default LongPostInteractiveTextViewer; 